import React from 'react';
import { Box, Typography, Paper, IconButton } from '@mui/material';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { documentCardSx } from '../../theme/terminalStyles';
import StocktakeCompareDot from './StocktakeCompareDot';
import { getCompareStatus, getLineReferenceQty, getLineReferenceLabel } from '../../helpers/stocktakeLineCompare';

const LIST_DOT_SIZE = 24;

const formatArticle = (product) => {
  const a = product?.article;
  if (a == null || String(a).trim() === '') return '—';
  return String(a).trim();
};

const StocktakeLineCard = ({
  line,
  fromERP,
  onOpen,
  onDelete,
  isSpotlighted,
  deleteEnabled,
}) => {
  const product = line.product;
  const article = formatArticle(product);
  const name = product ? `${product.name || ''} ${product.modName || ''}`.trim() : '—';
  const doc = getLineReferenceQty(line, fromERP);
  const refLabel = getLineReferenceLabel(fromERP);
  const fact = Number(line.quantityActual ?? 0);
  const compareStatus = getCompareStatus(doc, line.quantityActual);

  return (
    <Paper
      data-line-id={line.id}
      sx={{
        ...documentCardSx,
        position: 'relative',
        pr: { xs: !fromERP && deleteEnabled ? 9 : 5, sm: !fromERP && deleteEnabled ? 9 : 5 },
        ...(isSpotlighted
          ? {
              '@keyframes stocktakeRowGlow': {
                '0%, 100%': { boxShadow: '0 2px 10px rgba(0, 0, 0, 0.07)' },
                '50%': {
                  boxShadow: '0 0 0 3px rgba(255, 179, 71, 0.9), 0 4px 16px rgba(0, 0, 0, 0.15)',
                },
              },
              animation: 'stocktakeRowGlow 0.7s ease-in-out 4',
              borderColor: '#FFB347',
            }
          : {}),
      }}
      elevation={0}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
        }}
      >
        <IconButton aria-label="відкрити" size="small" onClick={onOpen} sx={{ color: 'text.primary' }}>
          <OpenInNewOutlinedIcon />
        </IconButton>
        {!fromERP && deleteEnabled ? (
          <IconButton
            aria-label="видалити"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onDelete?.(line);
            }}
            sx={{ color: '#c62828' }}
          >
            <DeleteOutlineIcon />
          </IconButton>
        ) : null}
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, flexWrap: 'nowrap' }}>
        <Box sx={{ flex: 1, minWidth: 0, pr: 0 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.25, wordBreak: 'break-word' }}>
            Артикул: <strong>{article}</strong>
          </Typography>
          <Typography variant="body1" fontWeight={600} sx={{ wordBreak: 'break-word', pr: 0.5 }}>
            {name}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1,
              mt: 0.75,
              minWidth: 0,
            }}
          >
            <Typography variant="body2" sx={{ minWidth: 0 }}>
              {refLabel}: <strong>{doc}</strong>
              {' · '}
              Факт: <strong>{fact}</strong>
            </Typography>
            <StocktakeCompareDot status={compareStatus} size={LIST_DOT_SIZE} />
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default StocktakeLineCard;
